import { ValidatorFn, Validators } from '@angular/forms';

/**
 * When `defaults.requireCustomerEmail` is explicitly `false`, branch/debtor email is optional (format only).
 * Absent or any other value means email is required during customer setup (QBC + POS + storefront approval).
 */
export function isCustomerEmailRequired(config: unknown): boolean {
	if (config === null || config === undefined || config === false) {
		return true;
	}
	const c = config as { defaults?: { requireCustomerEmail?: boolean } };
	return c.defaults?.requireCustomerEmail !== false;
}

export function customerBranchEmailValidators(config: unknown): ValidatorFn[] {
	return isCustomerEmailRequired(config) ? [Validators.required, Validators.email] : [Validators.email];
}
